(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('#header .menu li.dropdown > a').each(function () {
		var dropdown = $(this);
		var parentMenu = dropdown.parent();
		var toggler = $('<a href="#" class="icon-fold"></a>').insertAfter(dropdown);

		toggler.click(function(e) {
			e.preventDefault();

			parentMenu.toggleClass('open');
			$(this).parent().find('.dropdown-menu').toggleClass('open');

		});
	});
})();